import { useShop } from "@/lib/shop";

// Local-currency price of a product (Shopify Markets), e.g. "129 CHF", "€142.95", "$160".
export const Price = ({ role, installment = false }) => {
  const { priceOf } = useShop();
  return priceOf(role, installment);
};
